import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { actionCreators } from '@/store/myActiveTask'
import Icon from '@/components/Icon'
import { formatDate } from '@/utils/dateUtilities'
import { TaskActivationButton } from '@/internal-app/components/tasks/taskActivationButton'

const mapStateToProps = (state, ownProps) => ({
  activeTaskId: state.myActiveTask.activeTaskId,
  activating: state.myActiveTask.activating,
  ...ownProps
})
const mapDispatchToProps = {
  activateTask: actionCreators.activateTask,
  deactivateTask: actionCreators.deactivateTask
}

@connect(mapStateToProps, mapDispatchToProps)
class WidgetContent extends React.Component {
  render () {
    const { data, activateTask, deactivateTask, activating, activeTaskId } = this.props
    return (
      <div style={{ maxHeight: 260 }}>
        {(data || []).map(task => (
          <div key={task.id} className='d-task__row'>
            <Link className='task-text' to={`/tasks/${task.id}`}>
              <div className='task-title'>{task.name}</div>
              <div className='task__bot'>
                <div className='task-id'>
                  #<span className='task-id__number'>{task.id}</span>
                </div>

                <div className='task-time'>
                  <span className='time-created'>
                    <time>{formatDate(task.creationTime)}</time>
                  </span>

                  {task.dueDate &&
                  <React.Fragment>
                    <span className='time-due'>
                      [<Icon name='calendar-check' /> <time>{formatDate(task.dueDate)}</time>]
                    </span>
                  </React.Fragment>
                  }
                </div>
                <div className='active-task__event'>
                  {task.status < 2 &&
                    <TaskActivationButton showText taskId={task.id} activating={activating} activeTaskId={activeTaskId}
                      onActivate={activateTask} onDeactivate={deactivateTask} showButton />}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    )
  }
}

export default WidgetContent



// WEBPACK FOOTER //
// ./src/internal-app/components/tasks/widgetContent.js